import React from "react";
import ListViewOfESim from "./components/ListView";
import { SearchInput } from "../../components/search/SearchInput";

const ESimsPage: React.FC = () => {
  return (
    <div>
      <SearchInput />
      <div className="ui-container small-one pb-[5rem] pt-[2.8125rem]">
        <ListViewOfESim />
      </div>
    </div>
  );
};

export default ESimsPage;
